import { render, staticRenderFns } from "./TabletIcon.vue?vue&type=template&id=d9aa7cb8&scoped=true"
import script from "./TabletIcon.vue?vue&type=script&lang=js"
export * from "./TabletIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9aa7cb8",
  null
  
)

export default component.exports